export default __webpack_public_path__ + "static/media/LAS0770.34I-37187_-22000_0.413bd429.jpg";